// External libraries
import styled from '@emotion/styled';

// Internal modules
import { INFO_MESSAGE_BACKGROUND_COLOR_V2 } from '@/styles';

const CardIconContainer = styled.div`
  align-items: center;
  background-color: ${INFO_MESSAGE_BACKGROUND_COLOR_V2};
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding: 8px;
`;

const CardItem = styled.li`
  align-items: center;
  display: flex;
  padding: 0;
`;

const CardList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0;
`;

/* TEMPORARY COMPONENTS NEEDED FOR IE 11 HACK */
const CardArtContainer = styled.div`
  flex: 0 0 38px;
  height: 25px;
`;

const SvgWrapper = styled.div`
  height: 0;
  overflow: hidden;
  padding: 0;
  padding-bottom: 100%;
  position: relative;
  width: 38px;

  > svg {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;
/* END TEMPORARY COMPONENTS NEEDED FOR IE 11 HACK */

export { CardArtContainer, CardIconContainer, CardItem, CardList, SvgWrapper };
